import { render } from "./productGridTeaser.vue?vue&type=template&id=145f3114"
import script from "./productGridTeaser.vue?vue&type=script&lang=js"
export * from "./productGridTeaser.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__